import { render, staticRenderFns } from "./ImgTag.vue?vue&type=template&id=6c8d618a&scoped=true&"
import script from "./ImgTag.vue?vue&type=script&lang=js&"
export * from "./ImgTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8d618a",
  null
  
)

export default component.exports